module.exports = __webpack_public_path__ + "img/jo2.f510a3ff.png";